module.exports = __webpack_public_path__ + "static/media/payment2.cca69004.png";